// @ts-nocheck
import {
  FormControl,
  Grid
} from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import SelectBox from 'component/commonComponents/selectBox';
import GeneralDialog from "component/dialogComponents/generalDialog/generalDialog";
import PropTypes from 'prop-types';
import React, { memo, useState } from 'react';
import HlxButton from '../../commonComponents/button/button';
import { StyledLoadingProgress } from '../../commonComponents/loadingWithBackdrop/loadingWithBackdrop.style';
import parse from 'html-react-parser';

const FORM_CONSTANTS_NAME = {
  COUNTRY: 'country',
  PICKUP_LOCATION: 'pickupLocation'
};

const PickupLocationDialog = (props) => {
  const {
    onClose,
    open,
    defaultCountry,
    countryList,
    countryUserLogin,
    addressAfterSave,
    locale,
    dataPickupLocation,
    handleChangeCountry,
    isLoading,
    isYourSelf
  } = props;

  const dataLocation = dataPickupLocation?.map((item: any) => {
    return {
      name: item.name,
      code: item.uid
    }
  });

  const defaultAddress = {
    country: addressAfterSave?.country?.toLowerCase() || defaultCountry,
    pickupLocation: addressAfterSave?.pickupLocation || '',
    shipping_address: addressAfterSave?.shipping_address || '',
    name: addressAfterSave?.name || ''
  };
  const defaultValidation = {
    country: true,
    pickupLocation: true
  };
  const [address, setAddress] = useState(defaultAddress);
  const [validationFields, setValidationFields] = useState(defaultValidation);

  const handleChange = (event, fieldName) => {
    let val = '';
    if (event) {
      val = event?.target ? event.target.value : event.code;
    }

    if (fieldName === FORM_CONSTANTS_NAME.COUNTRY) {
      setAddress({
        ...address,
        [fieldName]: val,
        pickupLocation: '',
        shipping_address: '',
        name: ''
      });
      setValidationFields({
        ...validationFields,
        pickupLocation: true
      });
      handleChangeCountry(val);
    } else {
      setAddress({
        ...address,
        [fieldName]: val,
        shipping_address: dataPickupLocation.find(({ uid }) => uid === event?.code)?.shipping_address || '',
        name: dataLocation.find(item => item.code === val)?.name
      });
      setValidationFields({
        ...validationFields,
        [fieldName]: !!val
      });
    }
    

  };

  const validateField = (fieldName: string) => {
    setValidationFields({
      ...validationFields,
      [fieldName]: !!address[fieldName]
    });
  };
  
  const handleClose = async (event, isUpdateAddress = false) => { 
    let isValid = true,
      validFields = {};

    Object.keys(validationFields).forEach(ele => {
      if (!address[ele]) isValid = false;
      validFields = {
        ...validFields,
        [ele]: !!address[ele]
      };
    });

    if (isUpdateAddress) {
      setValidationFields({
        ...validationFields,
        ...validFields
      });
      if (isValid) {
        onClose(address, isUpdateAddress);
      }
    } else {
      // cancel button
      setAddress(defaultAddress);
      setValidationFields(defaultValidation);
      handleChangeCountry(isYourSelf ? countryUserLogin : addressAfterSave?.country?.toLowerCase() || defaultCountry);
      onClose(address, isUpdateAddress);
    }
  };

  if (countryList.length === 0) {
    return <></>;
  }

  const sortCountryList = (countryList: any[]) => {
    if (!Array.isArray(countryList) || countryList.length === 0) return [];

    return countryList.sort((a, b) => {
			const nameA = !!a.name && a.name.toUpperCase();
			const nameB = !!b.name && b.name.toUpperCase();
			return nameA < nameB ? -1 : (nameA > nameB ? 1 : 0);
		});
  };

  const buttonSubmit = (
    <HlxButton
      onClick={(event) => handleClose(event, true)}
      label={locale.txtOk}
    />
  );

  const content = (
    <>
      <Grid container className="form-container">
        <Grid container>
          <Grid xs={12} item>
            <FormControl
              width="100%"
              margin="dense"
              className="select-control"
            >
              <SelectBox
                id={FORM_CONSTANTS_NAME.COUNTRY}
                name={FORM_CONSTANTS_NAME.COUNTRY}
                label={locale.countryRegion}
                boldLabel
                value={countryList.find(({code}) => code === address.country)}
                handleChange={(e, val) => handleChange(val, FORM_CONSTANTS_NAME.COUNTRY)}
                fullWidth
                options={sortCountryList(countryList)}
                variant="outlined"
                required
                valueKey='code'
                locale={locale}
                disableClearable
              />
            </FormControl>
          </Grid>

          <Grid xs={12} item className="mt-20">
            {isLoading ? 
              <StyledLoadingProgress>
                <CircularProgress />
              </StyledLoadingProgress>
              :
              <>
                <FormControl
                  width="100%"
                  margin="dense"
                  className="select-control"
                >
                  <SelectBox
                    id={FORM_CONSTANTS_NAME.PICKUP_LOCATION}
                    name={FORM_CONSTANTS_NAME.PICKUP_LOCATION}
                    label={locale.addressType.pickUpLocation}
                    boldLabel
                    value={dataLocation.find(({ code }) => code === address.pickupLocation) || {}}
                    handleChange={(e, val) => handleChange(val, FORM_CONSTANTS_NAME.PICKUP_LOCATION)}
                    fullWidth
                    options={dataLocation || []}
                    variant="outlined"
                    required
                    valueKey='code'
                    locale={locale}
                    onBlur={() => validateField(FORM_CONSTANTS_NAME.PICKUP_LOCATION)}
                    error={!validationFields[FORM_CONSTANTS_NAME.PICKUP_LOCATION]}
                    disableClearable
                  />
                </FormControl>

                {!!address.shipping_address && <p><strong>Address:</strong> <br/>{parse(address.shipping_address.replace(/\n/g, '<br>'))}</p>}
              </>
            }

          </Grid>
        </Grid>
      </Grid>
    </>
  );

  return (
    <GeneralDialog
      title={locale.updateAddress}
      content={content}
      isOpen={open}
      handleClose={(event) => handleClose(event, false)}
      showComment={false}
      buttonSubmit={buttonSubmit}
      deviders={false}
      headerBackgroundDefault={false}
      cancelLabel={locale.txtCancel}
      classname="pickup-location-dialog"
    />
  );
};

PickupLocationDialog.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  locale: PropTypes.object,
  countryList: PropTypes.array,
  defaultCountry: PropTypes.string,
  countryUserLogin: PropTypes.string,
  addressAfterSave: PropTypes.object,
  dataPickupLocation: PropTypes.array,
  handleChangeCountry: PropTypes.func
};

PickupLocationDialog.defaultProps = {
  locale: {
    updateAddress: "Update Address",
    countryRegion: "Country/Region",
    txtOk: "OK",
    txtCancel: "CANCEL"
  }
};

export default memo(PickupLocationDialog);